import { defineComponent } from "vue";
import { Container } from "aurelia-dependency-injection";
import { mapState } from "pinia";

import { ReferralService } from "../../../../../../services/referral-service";
import { IPageCallbackResult } from "../../../../../../resources-vue/vue-interfaces/i-page-container";
import { PAGE_FAIL_RESPONSE } from "../../../../../../resources-vue/vue-elements/Pagination/Pagination";
import { useConvertToPendingPal } from "../../../store/useConvertToPendingPal";
import { ToastrService } from "../../../../../../services/toastr.service";

import FormSection from "../../../../../../resources-vue/vue-custom-elements/FormSection/FormSection.vue";
import Pagination from "../../../../../../resources-vue/vue-elements/Pagination/Pagination.vue";
import ErrorMessageHandler from "../../../../../../resources-vue/vue-custom-elements/ErrorMessageHandler/ErrorMessageHandler.vue";
import PreadmissionNotesRow from "./PreadmissionNotesRow/PreadmissionNotesRow.vue";

export default defineComponent({
    components: {
        FormSection,
        Pagination,
        ErrorMessageHandler,
        PreadmissionNotesRow
    },
    data(vm) {
        return {
            _referralService: null,
            _toastrService: null,
            page: null,
            isLoading: false,
            isError: false,
            columns: 4,
            noteList: null
        };
    },
    computed: {
        ...mapState(useConvertToPendingPal, [
            "patientDetails",
            "accountId",
            "application",
            "patientId",
            "patientReferralId"
        ]),
        loadingCount() {
            return this.page?.items?.length > 0 ? this.page.items.length() : 5;
        },
        hasData() {
            return this.page?.itemCount > 0;
        }
    },

    created() {
        this._referralService = Container.instance.get(ReferralService);
        this._toastrService = Container.instance.get(ToastrService);
    },

    mounted() {
        this.noteList = this.$refs.notesList;
        this.resetList();
    },

    methods: {
        async pageChangedCallback(pageNumber: number, pageSize: number): Promise<IPageCallbackResult> {
            try {
                this.isError = false;
                let data = await this._referralService.getPreadmissionNotes(
                    {
                        referralId: this.patientReferralId,
                        page: pageNumber,
                        pageLength: pageSize,
                        application: this.application,
                        accountId: this.accountId
                    },
                    this.patientReferralId
                );
                this.page = data;
                return {
                    totalPageCount: data.pageCount,
                    success: data.itemCount > 0,
                    totalCount: data.itemCount
                };
            } catch (e) {
                console.error(e);
                this.isError = true;
                return PAGE_FAIL_RESPONSE;
            }
        },
        resetList() {
            this.noteList.reset();
        }
    }
});
